(() => {
  angular.module('app').component('corporateBenefitGroupsCreateEditSpecialistComponent', {
    templateUrl: require('./specialist.component.html'),
    controller: CreateEditSpecialistController,
    controllerAs: 'vm',
    bindings: {
      currencyCode: '<',
      dependentHasSpecialist: '<',
      specialistTreatmentEditData: '<',
      benefitGroup: '<',
      areTreatmentTreeAndReferralExceptionsDirty: '=',
      isReadOnly: '<',
    },
  });

  CreateEditSpecialistController.$inject = ['abp.services.app.commonLookup', '$sce'];

  function CreateEditSpecialistController(commonLookupSvc, $sce) {
    const vm = this;

    vm.canUseReferralExceptions = abp.features.isEnabled('Specialist.CanUseReferralExceptions');
    vm.$onChanges = onChanges;
    vm.principalReferralExceptions = [];
    vm.dependentReferralExceptions = [];
    vm.principalSpecialistDisciplines = null;
    vm.dependentSpecialistDisciplines = null;
    vm.selectedPrincipalDisciplineException = null;
    vm.selectedDependentDisciplineException = null;

    vm.hasExclusionListForSpecialist = abp.setting.getBoolean(
      'Hms.Feature.ExclusionListForSpecialist'
    );

    vm.addDisciplineToPrincipalReferralExceptions = addDisciplineToPrincipalReferralExceptions;
    vm.addDisciplineToDependentReferralExceptions = addDisciplineToDependentReferralExceptions;
    vm.onPrincipalExceptionChanged = onPrincipalExceptionChanged;
    vm.onDependentExceptionChanged = onDependentExceptionChanged;
    vm.getDisciplines = getDisciplines;
    vm.displaySafeHtml = displaySafeHtml;

    vm.$onInit = init;

    function init() {}

    function onChanges(changes) {
      if (changes.benefitGroup && vm.canUseReferralExceptions) {
        getDisciplines();
      }
    }

    function getDisciplines() {
      commonLookupSvc.getSpecialistDisciplines().success((data) => {
        vm.principalSpecialistDisciplines = angular.copy(data.items);
        vm.dependentSpecialistDisciplines = angular.copy(data.items);

        const specialistDisciplinesById = _.chain(data.items)
          .keyBy('value')
          .mapValues('name')
          .value();

        vm.principalReferralExceptions = createReferralExceptionsModel(
          vm.benefitGroup.principalReferralExceptions,
          vm.principalSpecialistDisciplines,
          specialistDisciplinesById
        );

        vm.dependentReferralExceptions = createReferralExceptionsModel(
          vm.benefitGroup.dependentReferralExceptions,
          vm.dependentSpecialistDisciplines,
          specialistDisciplinesById
        );
      });
    }

    function createReferralExceptionsModel(
      referralExceptions,
      specialistDisciplines,
      specialistDisciplinesById
    ) {
      return _.map(referralExceptions, (specialistDisciplineId) => {
        _.remove(
          specialistDisciplines,
          (discipline) => discipline.value === specialistDisciplineId
        );

        return {
          id: specialistDisciplineId,
          name: specialistDisciplinesById[specialistDisciplineId] || 'Unknown discipline',
          isRemove: false,
        };
      });
    }

    function addDisciplineToPrincipalReferralExceptions(selectedDiscipline) {
      vm.principalReferralExceptions.push({
        id: selectedDiscipline.value,
        name: selectedDiscipline.name,
        isRemove: false,
      });

      removeDiscipline(selectedDiscipline, vm.principalSpecialistDisciplines);
      onPrincipalExceptionChanged();
    }

    function addDisciplineToDependentReferralExceptions(selectedDiscipline) {
      vm.dependentReferralExceptions.push({
        id: selectedDiscipline.value,
        name: selectedDiscipline.name,
        isRemove: false,
      });

      removeDiscipline(selectedDiscipline, vm.dependentSpecialistDisciplines);
      onDependentExceptionChanged();
    }

    function removeDiscipline(selectedDiscipline, specialistDisciplines) {
      _.remove(
        specialistDisciplines,
        (discipline) => discipline.value === selectedDiscipline.value
      );
    }

    function onPrincipalExceptionChanged() {
      vm.benefitGroup.principalReferralExceptions = getFilteredExceptions(
        vm.principalReferralExceptions
      );
    }

    function onDependentExceptionChanged() {
      vm.benefitGroup.dependentReferralExceptions = getFilteredExceptions(
        vm.dependentReferralExceptions
      );
    }

    function getFilteredExceptions(exceptions) {
      return _.chain(exceptions)
        .filter((e) => !e.isRemove)
        .uniq()
        .map((f) => f.id)
        .value();
    }

    function displaySafeHtml(html) {
      return $sce.trustAsHtml(html);
    }
  }
})();
